import axiosInstance from "../axios-instance";
import type {
  ForwardEnqueuedResponse,
  ForwardStatusResponse,
  RollForwardInfoResponse,
  RollForwardInitializedResponse,
  VersionForwardChangeResponse,
} from "./types";

/** src 워크북을 지정하고 AI 자동 매칭으로 표별 이월 짝을 초기화한다. */
export const initializeRollForwardInfo = async (
  workbookId: string,
  sourceWorkbookId: string,
): Promise<RollForwardInitializedResponse> => {
  const response = await axiosInstance.put(
    `/v2/workbooks/${workbookId}/roll-forward-info/${sourceWorkbookId}`,
  );
  return response.data as RollForwardInitializedResponse;
};

/** 확정된 표별 이월 짝 조회 (Step 2 진입 시 표시). */
export const getRollForwardInfo = async (
  workbookId: string,
): Promise<RollForwardInfoResponse> => {
  const response = await axiosInstance.get(
    `/v2/workbooks/${workbookId}/roll-forward-info`,
  );
  return response.data as RollForwardInfoResponse;
};

/** 표별 매칭 교정 — target 표의 src 표를 지정한다 (overwrite/tag 동일 src). */
export const correctRollForwardTable = async (
  workbookId: string,
  tableId: string,
  sourceTableId: string,
): Promise<void> => {
  await axiosInstance.patch(
    `/v2/workbooks/${workbookId}/roll-forward-info/tables/${tableId}`,
    undefined,
    { params: { source_table_id: sourceTableId } },
  );
};

/**
 * 확정된 이월 짝으로 선택 표(또는 전체)를 표 단위 백그라운드 실행 enqueue.
 * smart 면 스마트 롤포워드 — 이월 후 태깅이 부족한 표만 오토태깅으로 잇는다.
 */
export const enqueueForwardTasks = async (
  workbookId: string,
  tableIds?: string[],
  smart: boolean = false,
): Promise<ForwardEnqueuedResponse> => {
  const response = await axiosInstance.post(
    `/v2/workbooks/${workbookId}/forward/tasks`,
    { tableIds, smart },
  );
  return response.data as ForwardEnqueuedResponse;
};

/** 표 단위 forward 진행 상태(폴링). */
export const getForwardStatus = async (
  workbookId: string,
): Promise<ForwardStatusResponse> => {
  const response = await axiosInstance.get(
    `/v2/workbooks/${workbookId}/forward/status`,
  );
  return response.data as ForwardStatusResponse;
};

/** 버전 업데이트로 달라진 표 조회 — SNB 변경 알림의 원천. */
export const getVersionForwardChanges = async (
  workbookId: string,
): Promise<VersionForwardChangeResponse> => {
  const response = await axiosInstance.get(
    `/v2/workbooks/${workbookId}/version-forward-changes`,
  );
  return response.data as VersionForwardChangeResponse;
};

/** 변경 알림 처리 완료 표시 — 해당 주석을 열어봤을 때. */
export const resolveVersionForwardChanges = async (
  workbookId: string,
  tableIds: string[],
): Promise<void> => {
  await axiosInstance.post(
    `/v2/workbooks/${workbookId}/version-forward-changes/resolve`,
    { tableIds },
  );
};
